import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = '/aira-echo-logo.png';

export const Footer = ({ variant = 'default' }) => {
  const currentYear = new Date().getFullYear();

  if (variant === 'minimal') {
    return (
      <footer className="py-4 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 flex flex-col items-center gap-3">
          <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-4">
            <p className="text-sm text-gray-500">
              &copy; {currentYear} AIRA ECHO. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/terms" 
                className="text-sm text-gray-500 hover:text-white transition-colors"
                data-testid="footer-terms-link"
              >
                Terms
              </Link>
              <Link 
                to="/privacy" 
                className="text-sm text-gray-500 hover:text-white transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy
              </Link>
            </div>
          </div>
          <p className="text-[10px] text-gray-600 text-center">
            Filmo Mania Media Private Limited (OPC) · Saunda D Colliery, Near High School, District Ramgarh, Jharkhand, India – 829133
          </p>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-[#030014] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="AIRA ECHO" className="w-10 h-10" />
              <span className="font-bold text-xl text-white">AIRA ECHO</span>
            </Link>
            <p className="text-gray-400 text-sm max-w-md">
              Your AI Super App for everything - from creative content and business insights to life management and career growth. Powered by cutting-edge AI technology.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/signup" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/terms" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                  data-testid="footer-terms-link"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                  data-testid="footer-privacy-link"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/cookies" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                  data-testid="footer-cookies-link"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            &copy; {currentYear} AIRA ECHO. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/terms" 
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Terms
            </Link>
            <Link 
              to="/privacy" 
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Privacy
            </Link>
            <Link 
              to="/cookies" 
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Cookies
            </Link>
            <a 
              href="mailto:support@airaecho.com" 
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Contact
            </a>
          </div>
        </div>

        {/* Company Legal Info */}
        <div className="pt-4 text-center">
          <p className="text-[10px] text-gray-600">
            Filmo Mania Media Private Limited (OPC) · Saunda D Colliery, Near High School, District Ramgarh, Jharkhand, India – 829133
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
